import { render, staticRenderFns } from "./SidebarConsent.vue?vue&type=template&id=208c9a0e&scoped=true"
import script from "./SidebarConsent.vue?vue&type=script&lang=js"
export * from "./SidebarConsent.vue?vue&type=script&lang=js"
import style0 from "./SidebarConsent.vue?vue&type=style&index=0&id=208c9a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c9a0e",
  null
  
)

export default component.exports